// extracted by mini-css-extract-plugin
export const content = "work-module--content--1us85";
export const horizontalLine = "work-module--horizontalLine--1T43-";
export const tag = "work-module--tag--3K1tE";
export const moreLink = "work-module--moreLink--2FseZ";